import { render, staticRenderFns } from "./MapPredefinedBookmarks.vue?vue&type=template&id=31bc5ff2"
import script from "./MapPredefinedBookmarks.vue?vue&type=script&lang=js"
export * from "./MapPredefinedBookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports